import React from 'react';

import { TransmissionEvent, TransmissionEventChannelsProps } from '../types';

import { TransmissionEventChannel } from './TransmissionEventChannel';

/**
 * Context: A channel is a unique combination of toType:to, e.g. whatsapp:+491234567890
 * This reducer aggregates transmission events by channel
 */
const getTransmissionEventsByChannel = (
  transmissionEvents: TransmissionEvent[]
): Record<string, TransmissionEvent[]> => {
  return transmissionEvents.reduce(
    (dict: Record<string, TransmissionEvent[]>, event: TransmissionEvent) => {
      const channel = `${event.toType}:${event.to}`;

      return {
        ...dict,
        [channel]: dict[channel] ? [...dict[channel], event] : [event],
      };
    },
    {}
  );
};

export const TransmissionEventChannels: React.FC<
  TransmissionEventChannelsProps
> = ({ transmissionEvents, orderCreatedAt }) => {
  const transmissionEventsByChannel =
    getTransmissionEventsByChannel(transmissionEvents);

  return (
    <div className="space-y-3">
      {Object.entries(transmissionEventsByChannel).map(
        ([channel, channelEvents]) => (
          <TransmissionEventChannel
            key={channel}
            channelEvents={channelEvents}
            orderCreatedAt={orderCreatedAt}
          />
        )
      )}
    </div>
  );
};
